
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {SocialTypeCollection} from '@/model/collection/SocialTypeCollection'
import {FilterSocialTypeSchema} from '@/schema/resource/SocialType/FilterSocialTypeSchema'

@Component
export default class FilterSocialType extends Vue {
  @Prop({type: Object, required: true}) collection!: SocialTypeCollection

  schema = new FilterSocialTypeSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
